export const INIT_PROJECT_EMAIL_MODAL = 'INIT_PROJECT_EMAIL_MODAL';
export const SET_EMAILS = 'SET_EMAILS';
export const ADD_EMAIL = 'ADD_EMAIL';
export const ADD_RECIPIENT = 'ADD_RECIPIENT';
export const SET_RECIPIENTS = 'SET_RECIPIENTS';
export const SET_SHOW_MODAL = 'SET_SHOW_MODAL';
export const SAVED_PDFTRON_SUCCESS = 'SAVED_PDFTRON_SUCCESS';
export const RESET_PDFTRON_MESSAGES = 'RESET_PDFTRON_MESSAGES';
